<template>
  <div class="app-container">
    <list ref="list" @setDetails="setDetails">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.OrderId)">编辑</el-button>
            <el-button type="text" @click="details(row.OrderId)">{{row.Status==2?'查看':'审核'}}</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>订单详情</span>
      <div class="list-detail">
        <span>订单号：{{row.DocNo||'-'}}</span>
        <span>业务员：{{row.ClerkName||'-'}}</span>
        <span>备注：{{row.Remark||'-'}}</span>
        <span>订单金额：{{ Math.floor(row.Amount*100)/100||'-' }}</span>
      </div>
    </div>
    <div class="thinScroll" :style="'px;overflow-y:auto;width:100%'">
      <el-row class="mb0">
        <el-table :data="Details" border style="width:100%;" 
        show-summary :summary-method="getSummaries">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="BarCode" label="条码" align="center" min-width="100" />
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column prop="Model" label="规格型号" align="center" />
          <el-table-column prop="UnitName" label="单位" align="center" />
          <el-table-column prop="Offer" label="报价" align="right">
            <template slot-scope="{row}">{{$commonJs.toThousands(row.Offer)}}</template>
          </el-table-column>
          <el-table-column prop="Discount" label="折扣%" width="90" align="center" />
          <template v-if="DisposeTax == 1">
            <el-table-column label="无税单价" width="90" align="center">
              <template slot-scope="{row}">{{$commonJs.toThousands(row.NoTaxPrice)}}</template>
            </el-table-column>
            <el-table-column prop="TaxRate" label="税率/%" width="90" align="center" />
          </template>
          <el-table-column prop="Price" label="单价" width="90" align="right">
            <template slot-scope="{row}">{{$commonJs.toThousands(row.Price)}}</template>
          </el-table-column>
          <el-table-column prop="Quantity" label="数量" width="90" align="right" />
          <template v-if="DisposeTax == 1">
            <el-table-column label="税额" width="90" align="right">
              <template slot-scope="{row}">{{$commonJs.toThousands(row.TaxAmount)}}</template>
            </el-table-column>
          </template>
          <el-table-column prop="Amount" label="含税金额" width="90" align="right">
            <template slot-scope="{row}">{{$commonJs.toThousands(row.Amount)}}</template>
          </el-table-column>
          <el-table-column prop="NoTaxAmount" label="不含税金额" width="90" align="right">
            <template slot-scope="{row}">{{$commonJs.toThousands(row.NoTaxAmount)}}</template>
          </el-table-column>
          <el-table-column prop="num" label="包装数量" width="90" align="right" />
        </el-table>
      </el-row>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" :DisposeTax="DisposeTax" />
    <details-dialog ref="detailsDialog" @close-saved="reload" :DisposeTax="DisposeTax" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/purchase/business/order/list";
import editDialog from "@/components/purchase/business/order/editDialog";
import detailsDialog from "@/components/purchase/business/order/detailsDialog";

export default {
  name: "order",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
  },
  data() {
    return {
      api: require("@/api/purchase/order").default,
      optApi: require("@/api/sy/opt").default,
      Details: [],
      row: {},
      DisposeTax: "",
    };
  },
  mounted() {
    this.optApi.list({ Code: "PURCHASE" }).then((res) => {
      res.Data.forEach((e) => {
        if (e.OptText == "DisposeTax") {
          this.DisposeTax = e.OptValue;
        }
      });
    });
  },
  methods: {
    setDetails(list, row) {
      this.Details = list;
      this.row = row;
    },
    // details(id) {
    //   this.$refs.editDialog.openDetailsById(id)
    // },
    details(id) {
      this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.OrderId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const fieldNames = columns.map(col => col.property);
      fieldNames.forEach((field, index) => {
        if (field && ['Offer', 'NoTaxAmount','Quantity2','Quantity','CostPrice','TaxAmount','Amount','Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); 
          } else {
            sums[index] = '/';
          }
        } else {
          sums[index] = '';
        }
      });
      sums[0] = '合计';
      return sums;
    },
  },
};
</script>